"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __importDefault(require("../config"));
var rest_1 = require("@eres/rest");
var entities_1 = require("./entities");
var core_1 = require("@eres/core");
function getDateWiseTransactions(numberOfDays) {
    return rest_1.httpGet(config_1.default.projectionApi().endPoint() + "topNCounters?top=" + numberOfDays);
}
exports.getDateWiseTransactions = getDateWiseTransactions;
function searchTx(url, options, firstQuery) {
    if (firstQuery === void 0) { firstQuery = false; }
    if (!firstQuery)
        url = url + "?";
    if (options.areaIds && options.areaIds.length > 0) {
        for (var _i = 0, _a = options.areaIds; _i < _a.length; _i++) {
            var areaId = _a[_i];
            url = url + ("&" + options.filter.query + "=") + areaId;
        }
    }
    if (options.status && options.status !== entities_1.TxPropertyStatus.ALL) {
        url = url + "&propertyStatus=" + options.status;
    }
    if (options.isSummary === true) {
        url = url + "&data=Aggregated";
    }
    else {
        url = url + "&data=Flat";
    }
    return rest_1.httpGet(url);
}
function getCommunityLookups() {
    var url = config_1.default.tabuTxnApi().endPoint() + "communitywise/lookup/community/coordinate";
    return rest_1.httpGet(url);
}
exports.getCommunityLookups = getCommunityLookups;
function getTransactions(fromDate, toDate, options) {
    var url = config_1.default.tabuTxnApi().endPoint() + options.filter.key + ("/transaction/" + options.ProcedureId + "/details/?fromDate=");
    url = url + core_1.DateUtil.formatDate(fromDate, "YYYY-MM-DD", "en");
    url = url + "&toDate=" + core_1.DateUtil.formatDate(toDate, "YYYY-MM-DD", "en");
    return searchTx(url, options, true);
}
exports.getTransactions = getTransactions;
function getDailyFilterTransaction(date, options) {
    var url = config_1.default.tabuTxnApi().endPoint() + options.filter.key + ("/transaction/" + options.ProcedureId + "/details/");
    url = url + core_1.DateUtil.formatDate(date, "YYYY-MM-DD", "en");
    return searchTx(url, options);
}
exports.getDailyFilterTransaction = getDailyFilterTransaction;
function getMonthlyTransaction(month, year, options) {
    var url = config_1.default.tabuTxnApi().endPoint() + options.filter.key + ("/transaction/" + options.ProcedureId + "/details/" + year + "/" + month);
    return searchTx(url, options);
}
exports.getMonthlyTransaction = getMonthlyTransaction;
function getYearlyTransaction(year, options) {
    var url = config_1.default.tabuTxnApi().endPoint() + options.filter.key + ("/transaction/" + options.ProcedureId + "/details/" + year);
    return searchTx(url, options);
}
exports.getYearlyTransaction = getYearlyTransaction;
function getAreaLookups() {
    var url = config_1.default.areaTxAPI().endPoint() + "lookup/areas/coordinate";
    return rest_1.httpGet(url);
}
exports.getAreaLookups = getAreaLookups;
function getDailyTransactions(fromDate, toDate, transactionType) {
    var from = core_1.DateUtil.formatDate(fromDate, "YYYY-MM-DD", "en");
    var to = core_1.DateUtil.formatDate(toDate, "YYYY-MM-DD", "en");
    var url = config_1.default.areaTxAPI().endPoint() + ("transaction/daily/transactions/?fromDate=" + from + "&toDate=" + to + "&transactionType=" + transactionType);
    return rest_1.httpGet(url);
}
exports.getDailyTransactions = getDailyTransactions;
